import * as React from 'react';
import { styled } from '@mui/system';
import { FormControlLabel, FormGroup, Switch } from '@mui/material';
import colors from '../../../scss/colors';

export default function CustomizedSwitch({ checked = false, onChange, name}) {
    return (
        <FormGroup>
            <FormControlLabel
                control={
                    <Android12Switch 
                        checked={checked}
                        onChange={onChange}
                        name={name} 
                    />
                }
            />
        </FormGroup>
    );
}

const Android12Switch = styled(Switch)(({ theme, checked }) => ({
    padding: 0,
    width: 86,
    height: 36,
    fontWeight: 500,
    marginBottom: '15px',
    '& .MuiButtonBase-root.MuiSwitch-switchBase': {
        transform: 'translateX(2px)',
        padding: 2,
    },
    '& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(49px)',
        padding: 2
    },
    '& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': {
        backgroundColor: colors.PRIMARY_BLUE,
        opacity: 1
    },
    '& .MuiSwitch-track': {
        opacity: 1,
        background: colors.DISABLED_GREY,
        borderRadius: 25,
        '&::before, &::after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            width: 16,
            height: 16,
        },
        '&::before': {
            content: '"Yes"',
            color: colors.WHITE,
            visibility: checked ? 'visible' : 'hidden',
            left: 14,
            top: 15
        },
        '&::after': {
            content: '"No"',
            color: colors.WHITE,
            visibility: !checked ? 'visible' : 'hidden',
            right: 20,
            top: 15
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        width: 28,
        height: 28,
        margin: 2,
        backgroundColor: colors.WHITE,
    },
}));